import React, { useState } from 'react'
import { Dropdown, DropdownItem, DropdownMenu } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import type { DropdownProps } from 'semantic-ui-react';
import { handleErrors } from '~/utils/helpers';
import { DownloadService } from '~/api/services/downloadFiles';

interface Props {
  verificationStatus: boolean
  periodId: string
}

const StyledMenu = styled(Dropdown) <DropdownProps>`
  background: ${({ theme }) => theme?.firstColor} !important;
  color: white !important;

  .item {
    font-size: 15px !important;
    i {
      font-size: 15px !important;
    }
  }
`;

const Report: React.FC<Props> = ({ verificationStatus, periodId }) => {
  const { t } = useTranslation()

  const [isLoading, setIsLoading] = useState(false)

  async function handleDownloadFile(url, data?, name?) {
    setIsLoading(true)
    try {
      await DownloadService.downloadFileWithName(url, { ...data }, name ?? '')
    } catch (error) {
      handleErrors(error)
    }
    setIsLoading(false)
  }

  return <StyledMenu
    text={t('Report')}
    icon='cloud download'
    floating
    direction={'left'}
    labeled
    button
    className='icon'
    disabled={!verificationStatus}
    loading={isLoading}
  >
    <DropdownMenu>
      <DropdownItem
        onClick={() => handleDownloadFile('milk-money/milk-payment/additional/invoices/export', { periodId })}
        icon='file excel outline' text={t('Additional payment details')}
      />
    </DropdownMenu>
  </StyledMenu>
}
export default Report